export default {
  colors: {
    background: '#F6F5FC',
    darkerBackground: '#cac5e8',
    lighterBackground: '#fff',
    defaultBorder: '#dededf',
    backgroundWithOpacity: 'rgba(246, 245, 252, 0.7)',

    primary: {
      lighter: '#bbedfb',
      light: '#4aafff',
      main: '#3e94c5',
      dark: '#00011e',
    },

    gray: {
      900: '#566a7f',
      201: '#bcbcbc',
      200: '#bcbcbc',
      100: '#d9d9d9',
      75: '#E6E6E6',
      50: '#f1f1f1',
    },

    green: {
      500: '#3ea76a',
      100: '#c2ebd4',
    },

    orange: {
      500: '#da7c0f',
      100: '#fddcb2',
    },

    danger: {
      light: '#F97171',
      main: '#FC5050',
      dark: '#F63131',
    },
  },
};
